import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'react-quill/dist/quill.snow.css';
import 'prismjs/prism';
import 'prismjs/components/prism-bash';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-jsx';
import 'nprogress/nprogress.css';
import 'src/assets/css/prism.css';
import React from 'react';
import ReactDOM from 'react-dom';
// import { Provider } from 'react-redux';
import { enableES5 } from 'immer';
import Cookies from 'js-cookie';
import axios from 'axios';
import * as serviceWorker from 'src/serviceWorker';
import { ApolloProvider } from '@apollo/react-hooks';
import { SettingsProvider } from 'src/contexts/SettingsContext';
import client from './utils/GQLClient';
import App from 'src/App';
require('dotenv').config();

// Initialize the Amazon Cognito credentials provider



const axiosauthrefresh = require('axios-auth-refresh');


enableES5();

let accessToken = '';
let idToken = '';
const refreshAuthLogic = async (failedRequest) => {
  
  const rfsrt = Cookies.get('rfsrt');
  
  const options = {
    headers:  {rfsrt} ,
    withCredentials: true,
    skipAuthRefresh: true
  }
  const payload = {
    rfsrt : rfsrt,
  }
 
  if(process.env.REACT_APP_ENV === 'test'){
    return await axios
    .post('https://auth2.rovelabs.com/test/tokenRefresh',payload,{options})
    .then((tokenRefreshResponse) => {
        console.log("tokenRefreshResponse" , tokenRefreshResponse)
        accessToken = tokenRefreshResponse.data.data.AccessToken;
        idToken = tokenRefreshResponse.data.data.IdToken;
        failedRequest.response.config.headers.Authorization = `accessToken ${idToken}`;
        Cookies.set('accessToken', accessToken);
        Cookies.set('idToken', idToken);
        return Promise.resolve();
    });
  } else {
    return await axios
    .post('https://auth2.rovelabs.com/prod/tokenRefresh',payload,{options})
    .then((tokenRefreshResponse) => {
      console.log(tokenRefreshResponse);
      accessToken = tokenRefreshResponse.data.auth.access_token;
      idToken = tokenRefreshResponse.data.auth.id_token;
        failedRequest.response.config.headers.Authorization = `accessToken ${idToken}`;
        Cookies.set('accessToken', accessToken);
        Cookies.set('idToken', idToken);
        return Promise.resolve();
    });
  }
}
  axios.interceptors.request.use((request) => {
 
  const accessToken = Cookies.get('accessToken'); 
  const idToken = Cookies.get('idToken');
  const refreshToken = Cookies.get('rfsrt') 
  
  if(accessToken){
    request.headers = {'Authorization': `accessToken ${accessToken}`,
                      'IdToken': idToken,
                      'RefreshToken':refreshToken}
    //localStorageService.setToken(token)
  }
  return request;
})

axiosauthrefresh.default(axios, refreshAuthLogic, { pauseInstanceWhileRefreshing: true });

if (process.env.NODE_ENV !== 'development') {
  console.log = () => {};
}

ReactDOM.render(
  <ApolloProvider client={client}> 
    <SettingsProvider>
      <App />
    </SettingsProvider>
  </ApolloProvider>
  ,
  document.getElementById('root')
);

serviceWorker.register();